import { createFileRoute, redirect } from '@tanstack/react-router'
import { LandedCostNewScreen } from '@/features/purchasing-landed-costs/landed-cost-new-screen'
import { hasGrant } from '@/lib/me'

/** Route shell for a new landed cost. The API enforces `landed_cost.create`. */
export const Route = createFileRoute('/_authenticated/purchasing/landed-costs/new')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'landed_cost.create')) {
      throw redirect({ to: '/purchasing/landed-costs' })
    }
  },
  component: LandedCostNewScreen,
})
